/**
 * @description Fires custom event on document
 * @param {string} name Event name
 * @param {} detail Data payload
 */ export const fireCustomEvent = function(type, detail) {
    if (!type) {
        console.error('Event type is invalid');
        return;
    }
    const customEvt = new CustomEvent(type, {
        detail
    });
    document.dispatchEvent(customEvt);
};
